import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>404</h1>
            <p>opps!! This Page Not Found</p>
        </div>
    );
};

export default Notfound;